import React from "react";
import { Box, Typography } from "@mui/material";
import type { TenantError } from "../config/tenant";

interface TenantErrorPageProps {
	error: TenantError;
}

const messages: Record<TenantError, { title: string; subtitle: string }> = {
	CHAIN_NOT_FOUND: {
		title: "Property Not Found",
		subtitle:
			"Online check-in is not available for this address. Please check the link you received or contact the hotel directly.",
	},
	NETWORK_ERROR: {
		title: "Service Unavailable",
		subtitle:
			"We could not reach the check-in service. Please try again in a few moments.",
	},
};

const TenantErrorPage: React.FC<TenantErrorPageProps> = ({ error }) => {
	const { title, subtitle } = messages[error];

	return (
		<Box
			sx={{
				minHeight: "100dvh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "#FAF9F6",
				textAlign: "center",
				px: 3,
			}}
		>
			<Typography
				variant="h3"
				sx={{
					fontFamily: "'Playfair Display', serif",
					fontWeight: "bold",
					mb: 3,
					fontSize: { xs: "1.8rem", sm: "2.5rem" },
					color: "#333",
				}}
			>
				{title}
			</Typography>

			<Typography
				variant="body1"
				sx={{
					maxWidth: 500,
					color: "#666",
					fontSize: { xs: "1rem", sm: "1.15rem" },
					lineHeight: 1.6,
				}}
			>
				{subtitle}
			</Typography>

			<Typography
				variant="caption"
				sx={{ mt: 6, color: "#aaa" }}
			>
				{window.location.hostname}
			</Typography>
		</Box>
	);
};

export default TenantErrorPage;
